import axios from 'axios';
import Session from '../utils/Session';

export interface IRedirecionamentosResponse {
    id: string;
    origem: string;
    destino: string;
    criadoEm: Date;
    criadoPor: string;
}

export interface IRedirecionamentoRequest {
    origem: string;
    destino: string;
    criadoPor: string;
}

async function obterRedirecionamentos(): Promise<IRedirecionamentosResponse[]> {
    const response = await axios.get(
        `https://firestore.googleapis.com/v1/projects/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/databases/(default)/documents/redirect`,
        {
            headers: {
                Authorization: `Bearer ${Session.get()?.idToken ?? ''}`,
            },
        }
    );
    const dateRequest = new Date(response.headers['date'] ?? '');
    return parseDataRedirecionamentos(response.data, dateRequest);
}

async function obterRedirecionamento(id: string): Promise<IRedirecionamentosResponse> {
    const response = await axios.get(
        `https://firestore.googleapis.com/v1/projects/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/databases/(default)/documents/redirect/${id}`,
        {
            headers: {
                Authorization: `Bearer ${Session.get()?.idToken ?? ''}`,
            },
        }
    );
    const dateRequest = new Date(response.headers['date'] ?? '');
    return parseDataRedirecionamento(response.data, dateRequest);
}

async function salvarRedirecionamento(payload: IRedirecionamentoRequest): Promise<IRedirecionamentosResponse> {
    const data = parseFormToFirebase(payload);
    const response = await axios.post(
        `https://firestore.googleapis.com/v1/projects/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/databases/(default)/documents/redirect`,
        data,
        {
            headers: {
                Authorization: `Bearer ${Session.get()?.idToken ?? ''}`,
            },
        }
    );
    const dateRequest = new Date(response.headers['date'] ?? '');
    return parseDataRedirecionamento(response.data, dateRequest);
}

async function alterarRedirecionamento(id: string, payload: IRedirecionamentoRequest): Promise<IRedirecionamentosResponse> {
    const data = parseFormToFirebase(payload);
    const response = await axios.patch(
        `https://firestore.googleapis.com/v1/projects/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/databases/(default)/documents/redirect/${id}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${Session.get()?.idToken ?? ''}`,
            },
        }
    );
    const dateRequest = new Date(response.headers['date'] ?? '');
    return parseDataRedirecionamento(response.data, dateRequest);
}

async function deleteRedirecionamento(id: string) {
    await axios.delete(
        `https://firestore.googleapis.com/v1/projects/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/databases/(default)/documents/redirect/${id}`,
        {
            headers: {
                Authorization: `Bearer ${Session.get()?.idToken ?? ''}`,
            },
        }
    );
}

function parseDataRedirecionamentos(data: any, dateRequest: Date): IRedirecionamentosResponse[] {
    if (!data?.documents) {
        return [];
    }
    let forms: IRedirecionamentosResponse[] = [];
    for (let item of data?.documents) {
        forms.push(parseDataRedirecionamento(item, dateRequest));
    }
    return forms;
}

function parseDataRedirecionamento(item: any, dateRequest: Date): IRedirecionamentosResponse {
    const form: IRedirecionamentosResponse = {
        id: extractId(item?.name),
        origem: item?.fields?.origem?.stringValue,
        destino: item?.fields?.destino?.stringValue,
        criadoEm: new Date(item?.createTime ?? new Date()),
        criadoPor: item?.fields?.criadoPor?.stringValue,
    };
    return form;
}

function parseFormToFirebase(form: IRedirecionamentoRequest): any {
    const data: any = {
        fields: {
            origem: {
                stringValue: form.origem,
            },
            destino: {
                stringValue: form.destino,
            },
            criadoPor: {
                stringValue: form.criadoPor,
            },
        },
    };
    return data;
}

function extractId(id: string): string {
    return id.split('/')[6];
}

export default {
    obterRedirecionamentos,
    obterRedirecionamento,
    salvarRedirecionamento,
    alterarRedirecionamento,
    deleteRedirecionamento,
};
